import * as React from 'react';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../../../../../../common/components/table/constants';
import { getImportStatusHeaderDescription } from '../../../../../../import_data/utils/import_utils';
import ProjectActions from '../components/ProjectActions';
import { SUPPORTED_IMPORT_TYPES } from '../../../../../../import_data/constants/import_types';

const EmptyTableView = () => <p>You don&apos;t have any Projects yet.</p>;

export default ({ importTypeMetadata }) => {
  return {
    dataTrackingId: 'projectId',
    dataLoadingText: 'Loading projects',
    emptyElement: EmptyTableView,
    pageSize: DEFAULT_TABLE_PAGE_SIZE,
    multiSelectConfig: { selectionType: 'multi' },
    headerConfig: {
      title: 'Projects',
      description: getImportStatusHeaderDescription(importTypeMetadata),
      Actions: ProjectActions,
      importTypeMetadata,
    },
    // TODO : This needs to be dynamic
    getDataRequestBody: () => {
      return {};
    },
    getImportDataRequestBody: () => {
      return {
        body: {
          importTypes: SUPPORTED_IMPORT_TYPES.QNQ_PROJECTS,
        },
      };
    },
  };
};
